import { css } from '@emotion/core';
var image = {
  name: "c7l9oc",
  styles: "width:100%;height:100%;max-height:220px;"
};
export var imgSquare = /*#__PURE__*/css(image, " object-fit:cover;");
export var imgWide = /*#__PURE__*/css(image, " object-fit:cover;");
export var imgSquarePlaceholder = /*#__PURE__*/css(image, " object-fit:contain;");
export var imgWidePlaceholder = /*#__PURE__*/css(image, " object-fit:contain;");